module.exports = __webpack_public_path__ + "691abeb243330be0e9cc791f0d0cbcec.png";